import React from "react";

const Button = ({ type, onClick, children, className, isDisabled, title }) => {
  return (
    <button
      type={type || "button"}
      onClick={onClick}
      className={className}
      disabled={isDisabled ? true : false}
      title={title}
    >
      {children}
    </button>
  );
};

export default Button;
